import { auth } from "../api/resources";
import { getToken, setSession } from "./store";

/**
 * H5 has no wx.login. We boot anonymously and lazily mint a dev openid so
 * favorites + outbound clicks can be tied to a user. Persisted across reloads
 * via localStorage.
 *
 * Production-grade login (WeChat OAuth web flow / phone number / etc.) is out
 * of scope for this preview build.
 */
const DEV_OPENID_KEY = "glow_h5_dev_openid";

function readOrCreateDevOpenid(): string {
  let openid = localStorage.getItem(DEV_OPENID_KEY);
  if (!openid) {
    openid = `h5_${Math.random().toString(36).slice(2, 10)}_${Date.now().toString(36)}`;
    localStorage.setItem(DEV_OPENID_KEY, openid);
  }
  return openid;
}

export async function ensureSession(): Promise<void> {
  if (getToken()) return;
  try {
    const openid = readOrCreateDevOpenid();
    const { token, user } = await auth.login({ mockOpenid: openid });
    setSession(token, { id: user.id, openid: user.openid });
  } catch (err) {
    // eslint-disable-next-line no-console
    console.warn("[h5] session bootstrap failed", err);
  }
}
